import React, { cloneElement, ReactElement, ReactNode, useEffect } from 'react';
import SubmitButton from 'SharedComponents/SubmitButton';
import useTranslate from 'Hooks/useTranslate';
import { StepsWrapper } from 'SharedComponents/styled/forms/StepsWrapper';
import { StepStatus } from 'Interfaces/StepStatus';

const getStatusByIndex = (index: number, activeIndex: number) => {
    if (index === activeIndex) {
        return StepStatus.ACTIVE;
    }

    return index > activeIndex ? StepStatus.PENDING : StepStatus.COMPLETE;
};

const Steps: React.FunctionComponent<{
    activeStep: number;
    setIsLastStep: Function;
    children: ReactNode[];
    isLoading: boolean;
    formName: string | undefined;
    animatedBtnSubmitCta: boolean;
    stepKeys: string[];
}> = props => {
    const { tPlain } = useTranslate();
    const { activeStep, formName, animatedBtnSubmitCta, isLoading } = props;
    // `steps` filtered array to remove falsy values as `someCondition && <RenderMe />`
    // can result in a boolean `false` to be present in the array
    const steps = props.children.filter(element => !!element);
    const activeIndex = activeStep - 1;
    const totalSteps = steps.length;
    const isLastStep = activeStep === totalSteps;
    const { setIsLastStep } = props;

    useEffect(() => {
        if (isLastStep) {
            setIsLastStep(true);
        }
    }, [isLastStep, setIsLastStep]);

    return (
        <StepsWrapper>
            {steps.map((child, index) =>
                cloneElement(child as ReactElement, {
                    key: props.stepKeys[index],
                    status: getStatusByIndex(index, activeIndex),
                })
            )}
            <SubmitButton
                name={formName}
                type="submit"
                addWiggleEffect={animatedBtnSubmitCta}
                buttonText={tPlain(isLastStep ? 'signupOverlay_Registration button' : 'signupOverlay_continue')}
                isLoading={isLoading}
                className={
                    isLastStep
                        ? 'qa-login-signup-form__submit qa-signup-overlay-mock__btn-submit'
                        : 'qa-login-signup-form__continue qa-login-signup-form__btn-continue'
                }
            />
        </StepsWrapper>
    );
};

export default Steps;
